
export default {
  name: 'HideCompletedSwitch',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      i18n: 'pages.education.courses-list'
    }
  },

  computed: {
    switchVal: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
